import React from 'react';
import ServicesContext from '../../../contexts/ServicesContext';
import { useAuth } from '../../../contexts/AuthContext';
import { Table } from '../../../common-components/Table/Table';
import { DnpLink } from '../../../models/DnpLink';
import { useDnpLinksTable } from './useDnpLinksTable';
import { DnpLinksTableRow } from './DnpLinksTableRow';
import { DnpLinksTableHeader } from './DnpLinksTableHeader';
import { ContainerList, ContainerListHeader } from './styles';

interface IDnpLinksProps {
    dnpLinks?: DnpLink[];
    filterAreaHeight: number;
}

const DnpLinks: React.FC<IDnpLinksProps> = ({
    dnpLinks,
    filterAreaHeight
}) => {

    const { session } = useAuth();
    const { getWidthColumns } = useDnpLinksTable();

    const {
    } = React.useContext(ServicesContext);

    const widthColumn = React.useMemo(() => getWidthColumns() , []);

    const rowsRender = React.useMemo(() => {
        const render = dnpLinks?.map(dnpLink => {        
            return (
                <DnpLinksTableRow
                    key={`dnp-link-${dnpLink.id}`}
                    dnpLink={dnpLink}
                    widthColumn={widthColumn}
                />
            );
        }) || [];
        return render;
    }, [ dnpLinks, widthColumn ]);

    return (
        <>
            <ContainerListHeader>
                <Table>
                    <thead>
                        <DnpLinksTableHeader />
                    </thead>
                </Table>
            </ContainerListHeader>
            <ContainerList filterAreaHeight={filterAreaHeight}>
                <Table>
                    <tbody>
                        {rowsRender}
                    </tbody>
                </Table>
            </ContainerList>
        </>
    );
}

export {DnpLinks};